import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { EDIT } from "const"
import { hasAccess } from "client/utils"
import { markovModelsRoute } from "client/parts/routes"
import {
    PRM_MARKOV_MODEL,
    StoreType,
    addModal,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Textarea,
    Button,
    DivInput,
    UserIcon,
} from "client/components"

const Form = () => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)

    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editUrl = `${markovModelsRoute}/${EDIT}/${model.id}`

    const editAccess = hasAccess(PRM_MARKOV_MODEL, EDIT)

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.name}</Label>
                        <Input type="text" value={model.name} readOnly />
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.description}</Label>
                        <Textarea value={model.description} readOnly />
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.createdBy}</Label>
                        <DivInput><UserIcon user={userList[model.creator]} size="sm" /></DivInput>
                    </FormGroup>

                </Col>

                {
                    editAccess && (
                        <Col xs={12}>
                            <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                {lang.edit}
                            </Button>
                        </Col>
                    )
                }
            </Row>
        </PageForm>
    )
}
export default Form
